import o from "./index471.js";
import { createElementBlock as r, openBlock as s, createElementVNode as n, Fragment as l, renderList as m, createBlock as p, resolveDynamicComponent as i, normalizeClass as c, toDisplayString as d } from "vue";
/* empty css         */
import f from "./index231.js";
const u = ["data-component"], y = { class: "ml-5" };
function _(e, E, S, g, v, $) {
  return s(), r("div", {
    class: "flex items-center ms-stars-rating",
    "data-component": e.$options.name
  }, [
    (s(!0), r(l, null, m(e.stars, (t, a) => (s(), p(i(t), {
      key: a,
      class: c(["ms-stars-rating__star", {
        "text-supernova": t !== e.MsStarEmpty || e.yellowEmptyStars,
        "text-silver": t === e.MsStarEmpty && !e.yellowEmptyStars
      }])
    }, null, 8, ["class"]))), 128)),
    n("span", y, d(e.label), 1)
  ], 8, u);
}
const w = /* @__PURE__ */ f(o, [["render", _], ["__scopeId", "data-v-2cac27f2"]]);
export {
  w as default
};
